import React from 'react';

const icUpload = (
    <svg width='20' height='21' viewBox='0 0 20 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M18.2809 12.7027C16.5222 14.2127 14.7834 14.0027 13.0047 14.0027V12.0027C14.8634 12.0027 15.7228 12.1427 16.732 11.4527C19.1503 9.80265 17.8912 5.90265 14.9033 6.01265C13.5743 -0.597349 3.18162 1.64266 5.25016 8.44266C2.62201 6.35266 -0.465808 12.0027 5.12024 12.0027C5.78977 12.0027 6.33938 12.0027 7.00891 12.0027V14.0027H4.2109C0.873257 14.0027 -1.17531 10.4427 0.733345 7.72266C1.6427 6.42266 3.0717 6.10266 3.0717 6.10266C3.73124 0.992663 9.5671 -1.70735 13.8841 1.18265C15.7427 2.42265 16.4422 4.24266 16.4422 4.24266C20.1596 5.37266 21.2788 10.1227 18.2809 12.7027ZM10.0068 6.00266L6.29942 9.71266L7.70843 11.1227L8.99751 9.83266C8.99751 13.4427 8.99751 16.3627 8.99751 20.0027H10.9961C10.9961 16.3427 10.9961 13.5227 10.9961 9.83266L12.2852 11.1227L13.6942 9.71266L10.0068 6.00266Z'
            fill='#6347FF'
        />
    </svg>
);

export default icUpload;
